var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListView(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5 3h-15a.5.5 0 0 1 0-1h15a.5.5 0 0 1 0 1M23.5 11h-15a.5.5 0 0 1 0-1h15a.5.5 0 0 1 0 1M23.5 19h-15a.5.5 0 0 1 0-1h15a.5.5 0 0 1 0 1M1.5 1a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-2zm2 4h-2C.673 5 0 4.327 0 3.5v-2C0 .673.673 0 1.5 0h2C4.327 0 5 .673 5 1.5v2C5 4.327 4.327 5 3.5 5zM1.5 9a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-2zm2 4h-2C.673 13 0 12.327 0 11.5v-2C0 8.673.673 8 1.5 8h2C4.327 8 5 8.673 5 9.5v2c0 .827-.673 1.5-1.5 1.5zM1.5 17a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-2zm2 4h-2C.673 21 0 20.327 0 19.5v-2c0-.827.673-1.5 1.5-1.5h2c.827 0 1.5.673 1.5 1.5v2c0 .827-.673 1.5-1.5 1.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListView);
export default __webpack_public_path__ + "static/media/list-view.6c2a76e8.svg";
export { ForwardRef as ReactComponent };